module.exports = __webpack_public_path__ + "img/logo.a7027a40.png";